const dict = {
  languageName: 'Deutsch',
  locale: 'de',
  fallback: 'en',
  dir: 'ltr',

  // app
  'app.name': 'Kavykhi.Cloud',
  'app.title': (sub) => `${sub} - Kavykhi.Cloud`,

  // themes
  theme: 'Design',
  'theme.light': 'Hell',
  'theme.dark': 'Dunkel',
  'theme.system': 'System',
  'theme.sakura': 'Sakura',

  // generic
  email: 'E-Mail',
  password: 'Passwort',
  ok: 'OK',
  cancel: 'Abbrechen',
  retry: 'Wiederholen',
  copy: 'Kopieren',
  empty: '(keine Einträge)',
  loading: 'Wird geladen...',
  calculating: 'Berechnung...',
  error: 'Fehler',

  'in_development': 'Diese Seite befindet sich in der Entwicklung.',

  // errors
  'error.not_found': 'nicht gefunden',
  'error.name_conflict': 'Namenskonflikt',
  'error.bad_param': 'ungültiger Parameter',
  'error.wrong_auth': 'falsche Authentifizierung',
  'error.unauthorized': 'nicht autorisiert',
  'error.wrong_credentials': 'falsche Anmeldedaten',
  'error.wrong_provider': 'falscher Anbieter',
  'error.insufficient_privileges': 'unzureichende Rechte',
  'error.not_empty': 'nicht leer',
  'error.limit_exceeded': 'Limit überschritten',
  'error.already_member': 'bereits Mitglied',
  'error.not_finalized': 'nicht abgeschlossen',
  'error.already_finalized': 'bereits abgeschlossen',
  'error.unexpected_patch': 'unerwarteter Patch',
  'error.timeout': 'Zeitüberschreitung',
  'error.not_patch': 'kein Patch',
  'error.not_supported': 'nicht unterstützt',
  'error.unexpected_error': 'unerwarteter Fehler',

  // data sizes
  'datasize.B': 'B',
  'datasize.KiB': 'KiB',
  'datasize.MiB': 'MiB',
  'datasize.GiB': 'GiB',
  'datasize.TiB': 'TiB',

  // auth providers
  'auth.provider.steam': 'Steam',
  'auth.provider.github': 'GitHub',
  'auth.provider.gitlab': 'GitLab',
  'auth.provider.itch': 'itch.io',
  'auth.provider.twitch': 'Twitch',
  'auth.provider.discord': 'Discord',
  'auth.provider.google': 'Google',

  // auth dialog
  'auth.dialog.header': 'Authentifizierung',
  'auth.dialog.please_select': 'Bitte wählen Sie Ihren Konto-Anbieter zum Anmelden.',
  'auth.dialog.redirecting_to': (provider) => `Weiterleitung zu ${provider}...`,
  'auth.dialog.remember_me': 'Angemeldet bleiben',
  'auth.dialog.log_in': 'Anmelden',
  'auth.dialog.back': 'Zurück',
  'auth.dialog.progress_header': 'Authentifizierung...',
  'auth.dialog.error.header': 'Authentifizierungsfehler',
  'auth.dialog.error.auth_not_allowed': 'Diese Anmeldedaten wurden vom Benutzer für die Authentifizierung gesperrt. Bitte nutzen Sie andere Anmeldedaten.',
  'auth.dialog.error.unknown': 'Ungültige Authentifizierungsparameter. Bitte versuchen Sie es erneut.',
  'auth.dialog.error.back': 'Zurückgehen',

  'user.profile': 'Profil',
  'user.logout': 'Abmelden',

  // deploy credential providers
  'deploy_credential_provider.steam': 'Steam',
  'deploy_credential_provider.itch': 'itch.io',

  'page_not_found.header': 'Seite nicht gefunden',
  'page_not_found.message': 'Diese Seite existiert nicht.',
  'page_not_found.message2': 'Nun, eigentlich schon, aber hier gibt es nichts. Folgende Möglichkeiten bestehen:',
  'page_not_found.items': [
    'Hier war früher etwas, wurde aber gelöscht.',
    'Hier ist noch etwas, aber Sie haben keinen Zugriff.',
    'Oder jemand war beim Kopieren und Einfügen des Links unvorsichtig.',
  ],

  'home': 'Startseite',
  'home.header.hint': 'Cloud-Tools für Indie-Entwickler',
  'home.description': 'Kavykhi.Cloud ist eine Entwicklungsplattform für Indie-Spiele. Wir unterstützen Download- und Browser-Spiele, private und öffentliche Builds, Branches, Teams und vieles mehr.',
  'home.auth': 'Anmelden oder Registrieren',
  'home.auth.hint': 'Neues Konto erstellen oder in bestehendes einloggen',

  'projects': 'Projekte',
  'projects.hint': 'Die Projekte, an denen Sie arbeiten',
  'projects.project': (project) => `Projekt: ${project}`,
  'projects.project.hint': 'Projekt',
  'projects.no_projects': 'Sie haben noch keine Projekte.',
  'projects.new': 'Projekt erstellen',
  'projects.new_dialog.header': 'Neues Projekt',
  'projects.new_dialog.label': 'Projektname',
  'projects.new_dialog.ok': 'Projekt erstellen',
  'projects.store_page': 'Öffentliche Store-Seite',
  'projects.description': 'Beschreibung',
  'projects.branches': 'Branches',
  'projects.versions': 'Versionen',
  'projects.packages': 'Pakete',
  'projects.management': 'Projekteinstellungen',
  'projects.management.breadcrumb': 'Einstellungen',
  'projects.management.title': (projectTitle) => `${projectTitle} - Einstellungen`,
  'projects.management.hint': 'Projekteinstellungen',
  'projects.management.users': 'Teammitglieder',
  'projects.management.users.empty': 'Keine Teammitglieder.',
  'projects.management.users.role.tester': 'Tester',
  'projects.management.users.role.developer': 'Entwickler',
  'projects.management.users.role.admin': 'Administrator',
  'projects.management.users.role.owner': 'Inhaber',
  'projects.management.users.role.starred': 'Favorisiert',
  'projects.management.users.exile': 'Aus Team entfernen',
  'projects.management.users.exile.dialog.header': 'Aus Team entfernen',
  'projects.management.users.exile.dialog.message': (projectTitle, userTitle) => <>Sind Sie sicher, dass Sie {userTitle} aus dem Projekt {projectTitle} entfernen möchten?</>,
  'projects.management.users.exile.dialog.ok': 'Aus Team entfernen',
  'projects.management.invites.one_time_invite': 'Einmaliger Einladungslink',
  'projects.management.invites.one_time_invite.header': 'Einmaliger Einladungslink',
  'projects.management.invites.one_time_invite.message': 'Einmaliger Einladungslink:',
  'projects.management.invites.one_time_invite.note': 'Gültig für 24 Stunden, kann einmal verwendet werden.',
  'projects.management.invites.new_dialog.header': 'Einladungslink',
  'projects.management.invites.new_dialog.expires': 'Ablauf in:',
  'projects.management.invites.new_dialog.expires.indefinite': '(kein Ablauf)',
  'projects.management.invites.new_dialog.approval.label': 'Benutzer tritt Projekt bei:',
  'projects.management.invites.new_dialog.approval.not_approved': 'nach Admin-Freigabe',
  'projects.management.invites.new_dialog.approval.approved': 'sofort',
  'projects.management.invites.new_dialog.seats': 'Beitrittslimit:',
  'projects.management.invites.new_dialog.seats.no_limit': '(kein Limit)',
  'projects.management.invites.new_dialog.ok': 'Einladungslink erstellen',
  'projects.management.deploy_sites': 'Deploy-Seiten',
  'projects.management.deploy_sites.empty': 'Keine Deploy-Seiten hinzugefügt.',
  'projects.management.deploy_sites.add': 'Deploy-Seite hinzufügen',
  'projects.management.deploy_sites.delete': 'Löschen',
  'projects.management.deploy_sites.delete_dialog.header': 'Deploy-Seite löschen',
  'projects.management.deploy_sites.delete_dialog.message': (provider, site) => <>Sind Sie sicher, dass Sie die {provider} Deploy-Seite {site} löschen möchten?</>,
  'projects.management.deploy_sites.delete_dialog.ok': 'Deploy-Seite löschen',
  'projects.management.public_access': 'Öffentlicher Zugriff',
  'projects.management.public_access.enable': 'Öffentlichen Zugriff aktivieren',
  'projects.management.public_access.enabled': <>Öffentlicher Zugriff: <strong>erlaubt</strong></>,
  'projects.management.public_access.enabled.note': 'Der Name und die Beschreibung des Projekts sind öffentlich, ebenso wie alle als öffentlich markierten Branches.',
  'projects.management.public_access.enable_dialog.header': 'Öffentlichen Zugriff aktivieren',
  'projects.management.public_access.enable_dialog.message': (projectTitle) => <>Sind Sie sicher, dass Sie den öffentlichen Zugriff auf das Projekt {projectTitle} erlauben möchten?<br /><br />Dadurch werden grundlegende Informationen über das Projekt ohne Authentifizierung verfügbar. Sie müssen den öffentlichen Zugriff für jeden Branch, den Sie veröffentlichen möchten, separat aktivieren.</>,
  'projects.management.public_access.enable_dialog.ok': 'Öffentlichen Zugriff aktivieren',
  'projects.management.public_access.disable': 'Öffentlichen Zugriff deaktivieren',
  'projects.management.public_access.disabled': <>Öffentlicher Zugriff: <strong>nicht erlaubt</strong></>,
  'projects.management.public_access.disabled.note': 'Das Projekt ist privat. Nur Mitglieder des Projektteams können darauf zugreifen.',
  'projects.management.public_access.disable_dialog.header': 'Öffentlichen Zugriff deaktivieren',
  'projects.management.public_access.disable_dialog.message': (projectTitle) => <>Sind Sie sicher, dass Sie den gesamten öffentlichen Zugriff auf das Projekt {projectTitle} deaktivieren möchten?</>,
  'projects.management.public_access.disable_dialog.ok': 'Öffentlichen Zugriff deaktivieren',
  'projects.management.public_access.branches': 'Öffentliche Branches',
  'projects.management.manage': 'Projekt verwalten',
  'projects.rename': 'Projekt umbenennen',
  'projects.rename_dialog.header': 'Projekt umbenennen',
  'projects.rename_dialog.label': 'Projektname:',
  'projects.rename_dialog.ok': 'Projekt umbenennen',
  'projects.edit_description': 'Beschreibung bearbeiten',
  'projects.edit_description_dialog.header': 'Projektbeschreibung bearbeiten',
  'projects.edit_description_dialog.label': 'Projektbeschreibung:',
  'projects.edit_description_dialog.ok': 'Beschreibung speichern',
  'projects.leave': 'Projekt verlassen',
  'projects.leave_dialog.header': 'Projekt verlassen',
  'projects.leave_dialog.message': (projectTitle) => <>Sind Sie sicher, dass Sie das Projekt {projectTitle} verlassen möchten?</>,
  'projects.leave_dialog.ok': 'Projekt verlassen',
  'projects.delete': 'Projekt löschen',
  'projects.delete_dialog.header': 'Projekt löschen',
  'projects.delete_dialog.message': (projectTitle) => <>Sind Sie sicher, dass Sie das Projekt {projectTitle} löschen möchten?</>,
  'projects.delete_dialog.ok': 'Projekt löschen',

  'branches.header': (projectTitle, branchTitle) => `${projectTitle}: ${branchTitle}`,
  'branches.header.hint': 'Branch',
  'branches.no_branches': 'Das Projekt hat noch keine Branches',
  'branches.new': 'Branch erstellen',
  'branches.new_dialog.header': 'Neuer Branch',
  'branches.new_dialog.label': 'Branch-Name',
  'branches.new_dialog.ok': 'Branch erstellen',
  'branches.current_version': (version) => <>Aktuelle Version: {version}</>,
  'branches.current_version.packages': 'Pakete der aktuellen Version',
  'branches.no_current_version': 'Keine aktuelle Version',
  'branches.publish_version.new': 'Neue Version veröffentlichen',
  'branches.publish_version.existing': 'Bestehende Version erneut veröffentlichen',
  'branches.version_history': 'Versionsverlauf',
  'branches.version_history.empty': 'Der Versionsverlauf des Branches ist leer.',
  'branches.version_history.note_removal': ({ quotaCount, quotaCountText, quotaNonCurrentTime, quotaTime }) => <>Die aktuelle Branch-Version wird {quotaTime != null ? <>für {quotaTime}</> : <>unbegrenzt</>} aufbewahrt. Vorherige Versionen werden maximal {quotaNonCurrentTime} aufbewahrt. Es werden maximal {plural(quotaCount, <>{quotaCountText} Version</>, <>{quotaCountText} Versionen</>)} insgesamt pro Branch gespeichert.</>,
  'branches.manage': 'Branch verwalten',
  'branches.rename': 'Branch umbenennen',
  'branches.rename_dialog.header': 'Branch umbenennen',
  'branches.rename_dialog.label': 'Branch-Name:',
  'branches.rename_dialog.ok': 'Branch umbenennen',
  'branches.delete': 'Branch löschen',
  'branches.delete_dialog.header': 'Branch löschen',
  'branches.delete_dialog.message': (branchTitle) => <>Sind Sie sicher, dass Sie den Branch {branchTitle} löschen möchten?</>,
  'branches.delete_dialog.ok': 'Branch löschen',

  'versions.header': (projectTitle, versionTitle) => `${projectTitle} ${versionTitle}`,
  'versions.header.hint': 'Version',
  'versions.current': 'Aktuell',
  'versions.previous': 'Vorherige',
  'versions.description': 'Beschreibung',
  'versions.deploy_to_site.header': 'Auf Seite veröffentlichen',
  'versions.deploy_to_site': 'Auf Seite veröffentlichen',
  'versions.packages': 'Pakete',
  'versions.branches': 'In Branches',
  'versions.branches.publish': 'In Branch veröffentlichen',
  'versions.branches.empty': 'Die Version wurde in keinem Branch veröffentlicht.',
  'versions.new_dialog.header': 'Neue Version',
  'versions.new_dialog.label_title': 'Version:',
  'versions.new_dialog.label_branch': 'Branch:',
  'versions.new_dialog.packages.header': 'Pakete',
  'versions.new_dialog.packages.empty': 'Keine Pakete hinzugefügt.',
  'versions.new_dialog.packages.add': 'Paket hinzufügen',
  'versions.new_dialog.packages.add_existing': 'Zuvor hochgeladenes Paket hinzufügen',
  'versions.new_dialog.packages.replace': 'Paket ersetzen',
  'versions.new_dialog.packages.edit': 'Paket bearbeiten',
  'versions.new_dialog.ok': 'Version erstellen',
  'versions.manage': 'Version verwalten',
  'versions.rename': 'Version umbenennen',
  'versions.rename_dialog.header': 'Version umbenennen',
  'versions.rename_dialog.label': 'Versionsname:',
  'versions.rename_dialog.ok': 'Version umbenennen',
  'versions.edit_description': 'Versionsbeschreibung bearbeiten',
  'versions.edit_description_dialog.header': 'Versionsbeschreibung bearbeiten',
  'versions.edit_description_dialog.label': 'Versionsbeschreibung:',
  'versions.edit_description_dialog.ok': 'Beschreibung speichern',
  'versions.delete': 'Version löschen',
  'versions.delete_dialog.header': 'Version löschen',
  'versions.delete_dialog.message': (versionTitle) => <>Sind Sie sicher, dass Sie die Version {versionTitle} löschen möchten?</>,
  'versions.delete_dialog.ok': 'Version löschen',

  'versions.publish_dialog.header': 'Version in Branch veröffentlichen',
  'versions.publish_dialog.message': (versionTitle) => <>Wählen Sie den Branch aus, in dem die Version {versionTitle} veröffentlicht werden soll.</>,
  'versions.publish_dialog.no_branches': 'Keine Branches im Projekt.',
  'versions.publish_dialog.ok': 'Version veröffentlichen',

  'versions.publish_existing_dialog.header': 'Version erneut veröffentlichen',
  'versions.publish_existing_dialog.message': 'Letzte Versionen:',
  'versions.publish_existing_dialog.no_versions': 'Keine Versionen im Projekt.',
  'versions.publish_existing_dialog.ok': 'Version veröffentlichen',

  'packages.header': (projectTitle, packageTitle) => `${projectTitle}: ${packageTitle}`,
  'packages.header.hint': 'Paket',
  'packages.download_zip': 'Als ZIP herunterladen',
  'packages.download_torrent': 'Torrent herunterladen',
  'packages.total_size': (size) => <>Gesamtgröße: {size}</>,
  'packages.manage': 'Paket verwalten',
  'packages.rename': 'Paket umbenennen',
  'packages.rename_dialog.header': 'Paket umbenennen',
  'packages.rename_dialog.label': 'Paketname:',
  'packages.rename_dialog.ok': 'Paket umbenennen',
  'packages.edit_tags': 'Paket-Tags bearbeiten',
  'packages.edit_tags_dialog.header': 'Paket-Tags bearbeiten',
  'packages.edit_tags_dialog.message': (packageTitle) => <>Geben Sie Tags für das Paket {packageTitle} an:</>,
  'packages.edit_tags_dialog.ok': 'Tags speichern',
  'packages.entrypoint': (entrypoint) => <>Startdatei: {entrypoint}</>,
  'packages.entrypoint.empty': 'Keine Startdatei festgelegt.',
  'packages.delete': 'Paket löschen',
  'packages.delete_dialog.header': 'Paket verwerfen',
  'packages.delete_dialog.message': (packageTitle) => <>Sind Sie sicher, dass Sie das Paket {packageTitle} löschen möchten? Es wird aus allen Versionen entfernt, denen es hinzugefügt wurde.</>,
  'packages.delete_dialog.ok': 'Paket löschen',

  'packages.new_dialog.header': 'Neues Paket',
  'packages.new_dialog.label_title': 'Titel:',
  'packages.new_dialog.title_placeholder': '(aus Tags)',
  'packages.new_dialog.tags.header': 'Tags',
  'packages.new_dialog.files.header': 'Dateien',
  'packages.new_dialog.total_size': (size, maximum) => <>Gesamtgröße: {size} {maximum}</>,
  'packages.new_dialog.total_size.maximum': (size) => <>(maximal {size})</>,
  'packages.new_dialog.new_data_size': (size) => <>Neue Datengröße: {size}</>,
  'packages.new_dialog.checks.empty': 'Keine Dateien hinzugefügt.',
  'packages.new_dialog.checks.entrypoint.empty': 'Startdatei ist nicht festgelegt.',
  'packages.new_dialog.checks.entrypoint.missing': (entrypoint) => <>Die Startdatei {entrypoint} existiert nicht. Haben Sie vergessen, sie hinzuzufügen? Bitte geben Sie eine vorhandene Startdatei an oder lassen Sie das Feld leer.</>,
  'packages.new_dialog.checks.entrypoint.missing.action': 'Startdatei zurücksetzen',
  'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag) => <>Startdatei hat die Endung {fileExt}: Tag {tag} wird empfohlen.</>,
  'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag) => <>Tag {tag} hinzufügen</>,
  'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag) => <>Startdatei hat die Endung {fileExt}: Fügen Sie das Tag {tag} hinzu, um das Paket im Browser spielbar zu machen.</>,
  'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt) => <>Startdatei hat die Endung {fileExt}: Ist das ein Fehler? Normalerweise ist dies kein startbarer Dateityp.</>,
  'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt) => <>Startdatei hat die Endung {fileExt}: Es wird empfohlen, die eigentlichen Inhaltsdateien einzubinden, anstatt sie in ein Archiv zu packen.</>,
  'packages.new_dialog.checks.entrypoint.executable': 'Startdatei ist nicht als ausführbar markiert',
  'packages.new_dialog.checks.entrypoint.executable.action': 'Als ausführbar markieren',
  'packages.new_dialog.checks.single_root_dir': 'Es wird empfohlen, Dateien direkt im Stammverzeichnis abzulegen, anstatt einen einzelnen Ordner im Stammverzeichnis zu haben.',
  'packages.new_dialog.checks.single_root_dir.action': 'Ordner durch seinen Inhalt ersetzen',

  'packages.add_existing_dialog.header': 'Paket hinzufügen',
  'packages.add_existing_dialog.add': (packagesCount) => packagesCount > 0 ? `${plural(packagesCount, `${packagesCount} Paket`, `${packagesCount} Pakete`)} hinzufügen` : 'Keine Pakete ausgewählt',
  'packages.add_existing_dialog.message': 'Zuletzt hochgeladene Pakete:',
  'packages.add_existing_dialog.no_packages': 'Keine kürzlich hochgeladenen Pakete.',

  'packages.launch': 'Starten',

  'packages.install': 'Installieren',
  'packages.install_dialog.header': 'Installieren',
  'packages.install_dialog.workdir.label': 'Arbeitsverzeichnis:',
  'packages.install_dialog.workdir.value.new': '(neu erstellen)',
  'packages.install_dialog.workspace.label': 'Ordner erstellen unter:',
  'packages.install_dialog.workspace.placeholder': '(Stammordner wählen)',
  'packages.install_dialog.ok': 'Installieren',

  'packages.update': 'Aktualisieren',

  'packages.upload.status.existing': 'Aus vorheriger Version',
  'packages.upload.status.queued': 'In Warteschlange',
  'packages.upload.status.packing': 'Packen...',
  'packages.upload.status.creating': 'Erstellen...',
  'packages.upload.status.create_retrying': 'Erstellung fehlgeschlagen, erneuter Versuch...',
  'packages.upload.status.splitting': 'Aufteilen...',
  'packages.upload.status.uploading': 'Hochladen...',
  'packages.upload.status.finalizing': 'Abschließen...',
  'packages.upload.status.finalize_retrying': 'Abschluss fehlgeschlagen, erneuter Versuch...',
  'packages.upload.status.resolving': 'Patch auflösen...',
  'packages.upload.status.resolve_retrying': 'Patch-Auflösung fehlgeschlagen, erneuter Versuch...',
  'packages.upload.status.done': 'Erfolgreich hochgeladen',
  'packages.upload.status.errored': 'Fehler',

  'packages.upload.part.status.queued': 'In Warteschlange',
  'packages.upload.part.status.hashing': 'Hashing',
  'packages.upload.part.status.upload_queued': 'Upload in Warteschlange',
  'packages.upload.part.status.uploading': 'Hochladen',
  'packages.upload.part.status.upload_retrying': 'Fehler, Upload wird wiederholt',
  'packages.upload.part.status.upload_finalizing': 'Upload wird abgeschlossen',
  'packages.upload.part.status.upload_errored': 'Fehler',
  'packages.upload.part.status.done': 'Hochgeladen',

  'packages.play': 'Im Browser spielen',
  'packages.play.reset': 'Zurücksetzen',
  'packages.play.fullscreen': 'Vollbild',

  'deploy_sites.add_dialog.header': 'Deploy-Seite hinzufügen',
  'deploy_sites.add_dialog.message': (projectTitle) => <>Wählen Sie die Deploy-Anmeldedaten und geben Sie die Website-URL ein, um sie als Deploy-Seite für das Projekt {projectTitle} zu speichern.</>,
  'deploy_sites.add_dialog.label_credential': 'Deploy-Anmeldedaten:',
  'deploy_sites.add_dialog.select_credential': 'Anmeldedaten auswählen',
  'deploy_sites.add_dialog.select_credential.new': 'Neue Anmeldedaten hinzufügen...',
  'deploy_sites.add_dialog.label_select_site': 'Seite auswählen:',
  'deploy_sites.add_dialog.select_credential_first': '(zuerst Anmeldedaten wählen)',
  'deploy_sites.add_dialog.select_site': '(Seite auswählen)',
  'deploy_sites.add_dialog.label_enter_site': 'Oder Website-URL eingeben:',
  'deploy_sites.add_dialog.ok': 'Seite hinzufügen',

  'deploy_to_site_dialog.header': 'Auf Seite veröffentlichen',
  'deploy_to_site_dialog.message': (projectTitle, versionTitle) => <>Wählen Sie die Seite aus, auf der die Version {versionTitle} von {projectTitle} veröffentlicht werden soll.</>,
  'deploy_to_site_dialog.label_site': 'Auf Seite veröffentlichen:',
  'deploy_to_site_dialog.select_site': 'Seite auswählen',
  'deploy_to_site_dialog.select_site.new': 'Neue Deploy-Seite hinzufügen...',
  'deploy_to_site_dialog.packages.message.itch': <>Pakete werden auf itch.io mit <a href="https://itch.io/docs/butler/pushing.html" target="_blank">butler</a> veröffentlicht. Die Channel-Namen werden von den Paket-Tags abgeleitet.</>,
  'deploy_to_site_dialog.deploy': 'Veröffentlichen',
  'deploy_to_site_dialog.close': 'Schließen',
  'deploy_to_site_dialog.error.no_packages': 'Keine Pakete zum Veröffentlichen.',
  'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount, packagesCountText, channel }) => <>Mehrere Pakete können nicht im selben Channel veröffentlicht werden. Derzeit sind {plural(packagesCount, <>{packagesCountText} Paket</>, <>{packagesCountText} Pakete</>)} für die Veröffentlichung im Channel {channel} konfiguriert.</>,
  'deploy_to_site_dialog.job.queued': 'In Warteschlange',
  'deploy_to_site_dialog.job.downloading': 'Herunterladen...',
  'deploy_to_site_dialog.job.unpacking': 'Entpacken...',
  'deploy_to_site_dialog.job.uploading': 'Veröffentlichen...',
  'deploy_to_site_dialog.job.succeeded': 'Erfolgreich',
  'deploy_to_site_dialog.job.errored': 'Fehler',

  'store': 'Store',
  'store.hint': 'Öffentliche Projekte',
  'store.project.hint': 'Projektseite im Store',
  'store.project.owner': 'Entwickler',
  'store.project.description': 'Beschreibung',
  'store.project.star': 'Favorisieren',
  'store.project.starred': 'Favorisiert',
  'store.project.content': 'Inhalt',
  'store.project.content.warning': 'Dieser Inhalt wurde von einem Drittanbieter-Entwickler bereitgestellt.',
  'store.project.branch_version': (branchTitle, versionTitle) => <>Branch {branchTitle}: Version {versionTitle}</>,
  'store.project.branch_version.published': (branchVersionPublished) => <>Veröffentlicht: {branchVersionPublished}</>,

  'me': 'Profil',
  'me.hint': 'Profileinstellungen und verknüpfte Anmeldedaten',
  'me.rename': 'Profil umbenennen',
  'me.rename_dialog.header': 'Profil umbenennen',
  'me.rename_dialog.label_title': 'Name:',
  'me.rename_dialog.ok': 'Profil umbenennen',
  'me.credentials': 'Anmeldedaten',
  'me.credentials.hint.auth_allowed': 'Jede dieser Anmeldedaten kann verwendet werden, um sich bei diesem Konto anzumelden.',
  'me.credentials.hint.auth_disallowed': 'Diese Anmeldedaten sind mit Ihrem Konto verknüpft, können aber nicht zur Anmeldung verwendet werden.',
  'me.credentials.empty': 'Keine Anmeldedaten.',
  'me.credentials.empty.auth_allowed.warning': 'Sie könnten sich aus Ihrem Konto aussperren! Sie haben keine Anmeldedaten für den Login verknüpft. Bitte verknüpfen Sie so schnell wie möglich Anmeldedaten, mit denen Sie sich einloggen können.',
  'me.credentials.profile_picture.alt': (provider) => `Profilbild von ${dict[`auth.provider.${provider}`]}`,
  'me.credentials.created': (created) => <>hinzugefügt am {created}</>,
  'me.credentials.last_used': (lastUsed) => <>zuletzt verwendet am {lastUsed}</>,
  'me.credential.unlink': 'Verknüpfung aufheben',
  'me.credential.allow_auth': 'Login erlauben',
  'me.credential.disallow_auth': 'Login verbieten',
  'me.credential.display_publicly': 'Öffentlich anzeigen',
  'me.credential.dont_display_publicly': 'Nicht öffentlich anzeigen',
  'me.credential.link': 'Anmeldedaten verknüpfen',
  'me.credential.link_dialog.header': 'Anmeldedaten verknüpfen',
  'me.credential.link_dialog.message': 'Bitte wählen Sie den Konto-Anbieter aus, den Sie verknüpfen möchten.',
  'me.credential.unlink_dialog.header': 'Verknüpfung aufheben',
  'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle) => <>Sind Sie sicher, dass Sie das {credentialProvider}-Konto {credentialTitle} von Ihrem Kavykhi.Cloud-Konto trennen möchten?</>,
  'me.credential.unlink_dialog.ok': 'Verknüpfung aufheben',
  'me.sessions': 'Sitzungen',
  'me.sessions.hint': 'Dies ist eine Liste Ihrer aktiven Sitzungen, einschließlich Ihres aktuellen Browsers.',
  'me.sessions.started': (started) => <>gestartet am <span class="value">{started}</span></>,
  'me.sessions.last_auth': (lastAuth) => <>aktiv am <span class="value">{lastAuth}</span></>,
  'me.sessions.current': 'Aktuelle Sitzung',
  'me.sessions.empty': 'Keine Sitzungen.',
  'me.sessions.delete': 'Beenden',
  'me.sessions.delete_dialog.header': 'Sitzung beenden',
  'me.sessions.delete_dialog.message': 'Sind Sie sicher, dass Sie diese Sitzung beenden möchten?',
  'me.sessions.delete_dialog.ok': 'Sitzung beenden',
  'me.api_tokens': 'API-Token',
  'me.api_tokens.hint': 'API-Token können hier für die Automatisierung erstellt werden.',
  'me.api_tokens.started': (started) => <>erstellt am <span class="value">{started}</span></>,
  'me.api_tokens.expires': (expires) => <>läuft ab am <span class="value">{expires}</span></>,
  'me.api_tokens.no_expiration': 'kein Ablauf',
  'me.api_tokens.empty': 'Keine API-Token.',
  'me.api_tokens.create': 'API-Token generieren',
  'me.api_tokens.create_dialog.header': 'API-Token generieren',
  'me.api_tokens.create_dialog.message': 'Generierter API-Token:',
  'me.api_tokens.create_dialog.note': 'Der Token wird nicht noch einmal angezeigt, bitte speichern Sie ihn sicher ab.',
  'me.api_tokens.delete': 'Löschen',
  'me.api_tokens.delete_dialog.header': 'API-Token löschen',
  'me.api_tokens.delete_dialog.message': 'Sind Sie sicher, dass Sie diesen Token löschen möchten?',
  'me.api_tokens.delete_dialog.ok': 'API-Token löschen',
  'me.deploy_credentials': 'Deploy-Anmeldedaten',
  'me.deploy_credentials.hint': 'Anmeldedaten für das Deployment auf Publishing-Plattformen können hier hinzugefügt werden.',
  'me.deploy_credentials.empty': 'Keine Deploy-Anmeldedaten hinzugefügt.',
  'me.deploy_credential.add': 'Deploy-Anmeldedaten hinzufügen',
  'me.deploy_credential.add_dialog.header': 'Deploy-Anmeldedaten hinzufügen',
  'me.deploy_credential.add_dialog.label_site': 'Seite:',
  'me.deploy_credential.add_dialog.label_title': 'Notiz:',
  'me.deploy_credential.add_dialog.label_key': 'Schlüssel:',
  'me.deploy_credential.add_dialog.default_title': (date) => `Schlüssel ${date}`,
  'me.deploy_credential.add_dialog.ok': 'Deploy-Anmeldedaten hinzufügen',
  'me.deploy_credential.add_dialog.hint.itch': <>Um den itch.io-API-Schlüssel zu generieren, gehen Sie zu Ihren <a href="https://itch.io/user/settings/api-keys" target="_blank">Profileinstellungen</a> auf itch.io. Sie können einen bestehenden API-Schlüssel mit der Quelle "web" oder "wharf" verwenden. Ein API-Schlüssel mit der Quelle "Kavykhi.Cloud" funktioniert nicht.</>,
  'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider) => <>Das Hinzufügen von {credentialProvider}-Anmeldedaten wird derzeit nicht unterstützt.</>,
  'me.deploy_credential.delete': 'Löschen',
  'me.deploy_credential.delete_dialog.header': 'Deploy-Anmeldedaten löschen',
  'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider) => <>Sind Sie sicher, dass Sie die Anmeldedaten {credentialTitle} für {credentialProvider} löschen möchten? Alle mit diesen Anmeldedaten konfigurierten Deploy-Seiten werden ebenfalls aus dem Projekt entfernt.</>,
  'me.deploy_credential.delete_dialog.ok': 'Anmeldedaten löschen',
  'me.public_profile': 'Öffentliches Profil',
  'me.public_profile.public_credentials': 'Öffentliche Anmeldedaten',
  'me.public_profile.public_credentials.hint': 'Wählen Sie die Anmeldedaten aus, die öffentlich angezeigt werden sollen.',
  'me.manage': 'Konto verwalten',
  'me.delete': 'Konto löschen',
  'me.delete.dialog.header': 'Konto löschen',
  'me.delete.dialog.message': (userTitle) => <>Sind Sie sicher, dass Sie Ihr Kavykhi.Cloud-Konto {userTitle} unwiderruflich löschen möchten?</>,
  'me.delete.dialog.ok': 'Konto löschen',

  'invite': 'Einladung',
  'invite.hint': 'Projekteinladung',
  'invite.message.already_member': (projectTitle) => <>Sie sind bereits Mitglied des Projekts {projectTitle}.</>,
  'invite.message.join': (projectTitle) => <>Sie wurden zum Projekt {projectTitle} eingeladen.</>,
  'invite.join': 'Projekt beitreten',

  'local': 'Lokaler Inhalt',
  'local.hint': 'Lokal installierte Inhalte',
  'local.workdirs': 'Installierte Pakete',
  'local.workdirs.empty': 'Keine installierten Pakete.',
  'local.workdir.action.launch': 'Starten',
  'local.workdir.action.repair': 'Reparieren',
  'local.workdir.action.delete': 'Deinstallieren',
  'local.workdir.delete_dialog.header': 'Paket deinstallieren',
  'local.workdir.delete_dialog.message': (packageTitle) => <>Sind Sie sicher, dass Sie das Paket {packageTitle} von Ihrem Gerät deinstallieren möchten?</>,
  'local.workdir.delete_dialog.ok': 'Deinstallieren',
  'local.workspaces': 'Stammordner',
  'local.app_not_detected.message': 'Die lokale Kavykhi.Cloud-App wurde nicht erkannt. Bitte laden Sie sie über einen der folgenden Links herunter und installieren Sie sie. Wenn Sie sie bereits installiert haben, stellen Sie sicher, dass sie ausgeführt wird.',

  'local_app.detected': 'Lokaler Inhalt',

  'error_dialog.header': 'Fehler',
  'error_dialog.messageFunc': (e) => `Fehler: ${dict[`error.${e}`] ?? e}.`,

  'upload_box.choose_files': 'Dateien auswählen',
  'upload_box.choose_directories': 'Ordner auswählen',
  'upload_box.add.progress_dialog.header': 'Dateien werden hinzugefügt',
  'upload_box.add.progress_dialog.message': 'Dateien werden verarbeitet...',
  'upload_box.delete': (itemsCount) => `${plural(itemsCount, `${itemsCount} Element`, `${itemsCount} Elemente`)} löschen`,
  'upload_box.start_upload': 'Upload starten',
  'upload_box.drop_area.message': 'Dateien und Ordner hierher ziehen',
  'upload_box.drop_area.box_dropping_message': 'Hier ablegen, um ins Stammverzeichnis einzufügen',
  'upload_box.entry.explode_folder': 'Ordner durch Inhalt ersetzen',
  'upload_box.entry.set_entrypoint': 'Als Startdatei festlegen',
  'upload_box.entry.mark_executable': 'Als ausführbar markieren',
  'upload_box.entry.unmark_executable': 'Ausführbar-Markierung aufheben',
  'upload_box.entry.remove': 'Entfernen',

  'package.tags.empty': '(keine Tags)',
  'package.tag.os': 'Betriebssystem',
  'package.tag.os:windows': 'Windows',
  'package.tag.os:linux': 'Linux',
  'package.tag.os:macos': 'macOS',
  'package.tag.os:android': 'Android',
  'package.tag.os:ios': 'iOS',
  'package.tag.os:web': 'Web',
  'package.tag.arch': 'Architektur',
  'package.tag.arch:x86': 'x86',
  'package.tag.arch:arm': 'ARM',
  'package.tag.bits': 'Bit-Breite',
  'package.tag.bits:64': '64-Bit',
  'package.tag.bits:32': '32-Bit',
  'package.tag.packaging': 'Paketierung',
  'package.tag.packaging:installer': 'Installer',
  'package.tag.packaging:deb': '.deb',
  'package.tag.packaging:rpm': '.rpm',
  'package.tag.packaging:flatpak': 'Flatpak',
  'package.tag.component': 'Komponente',
  'package.tag.component:client': 'Client',
  'package.tag.component:server': 'Server',
  'package.tag.runtime': 'Laufzeitumgebung',
  'package.tag.runtime:nodejs': 'Node.js',
  'package.tag.runtime:java': 'Java',
  'package.tag.distro': 'Linux-Distribution',
  'package.tag.distro:ubuntu': 'Ubuntu',
  'package.tag.distro:fedora': 'Fedora',
  'package.tag.distro:arch': 'Arch Linux',
  'package.tag.distro:nixos': 'NixOS',

  'docs': 'Doku',
  'docs.page_no_language': 'In dieser Sprache nicht verfügbar',
  'docs.page_no_language.message': 'Andere Versionen dieses Dokuments sind verfügbar:',
  'docs.page_no_language.other_link': (doc, lang) => <>({lang}) {doc}</>,

  'social_links.discord': 'Discord',

  'report_content': 'Inhalt melden',
  'report_content.dialog.header': 'Inhalt melden',
  'report_content.dialog.link': 'Meldung per E-Mail senden',
  'report_content.dialog.message': (email, link) => <>Bitte klicken Sie auf den Link, um Ihre Meldung zu senden:<br /><br />{link}<br /><br />Oder senden Sie uns manuell eine E-Mail an {email}</>,
};

export default dict;

const plural = (n: number, one: string, many: string) => n == 1 ? one : many;
